import * as fromDatatype from '../datatype-library';

export interface bl_cms_website_settlement_method_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  website_hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_line_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  country_alpha2_code: fromDatatype.VarcharDatatypeInterface;
  country_alpha3_code: fromDatatype.VarcharDatatypeInterface;
}

export class bl_cms_website_settlement_method_link_RowClass implements bl_cms_website_settlement_method_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  website_hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_line_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  country_alpha2_code: fromDatatype.VarcharDatatypeInterface;
  country_alpha3_code: fromDatatype.VarcharDatatypeInterface;
}
